export default "__VITE_ASSET__BCEv0wvM__"